import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { menuLegacyDefaultV0Schema } from './default';

export type LegacyMenu = z.infer<typeof menuLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet). Single
 * placement, like indent/logo/navigation — no envelope union.
 */
export const LegacyMenuEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: menuLegacyDefaultV0Schema }]);
